import { Activityresult, CompanyResult, Trafficresult } from "models/StatisticsReport";
import generateBackgroundColors from "utility/generateBackgroundColors";
import Table from "../Components/Table";
import DoughnutChart from "../Charts/DoughnutChart";
import { useState } from "react";
import getProductsFromIds from "utility/getProductsFromIds";

interface ActivityAndTrafficProps {
    activity: Activityresult[],
    traffic: Trafficresult[],
    company: CompanyResult
}

const ActivityAndTraffic = ({activity, traffic, company}:ActivityAndTrafficProps) => {
    
    const [clickToggle, setClickToggle] = useState(false);
    const handleToggle = () => {
        setClickToggle(prev => !prev);
    }

    const clickToggleBaseClass = "card mb-4 cc-clickstat";
    const clickToggleClass = clickToggle ? "cc-open-clickstat" : "cc-close-clickstat";
    
    const activityChartLabels = activity.map((element) => element.name);
    const activityChartData = activity.map((element) => element.count);
    const activityTotalCount = new Intl.NumberFormat('nb-NO').format(activity.reduce((total, item) => total + item.count, 0));
    const {colors: activityBackgroundColors} = generateBackgroundColors(activityChartLabels.length);
    const activityChartDataset = [
        {
            data: activityChartData,
            backgroundColor: activityBackgroundColors,
            hoverBackgroundColor: activityBackgroundColors.map(color => color.replace('50%', '60%')),
            borderWidth: 0
        }
    ];

    const trafficChartLabels = traffic.map((element) => element.name);
    const trafficChartData = traffic.map((element) => element.count);
    const trafficTotalCount = new Intl.NumberFormat('nb-NO').format(traffic.reduce((total, item) => total + item.count, 0));
    const {colors: trafficBackgroundColors} = generateBackgroundColors(trafficChartLabels.length);
    const trafficChartDataset = [
        {
            data: trafficChartData,
            backgroundColor: trafficBackgroundColors,
            hoverBackgroundColor: trafficBackgroundColors.map(color => color.replace('50%', '60%')),
            borderWidth: 0
        }
    ];

    const getItems:string[] = getProductsFromIds(company.products, '428').map((item) => {
        return item.Values.Url;
    });
    
    return (
        <div className={`${clickToggleBaseClass} ${clickToggleClass}`} id="clickStat">
            <div className="card-header" id="toggleClickStat" onClick={handleToggle}>
                <h2 className="p2 d-flex justify-content-between align-items-center">
                    <span><big className="fw-bold">{activityTotalCount}</big> klikk til din bedrift</span> <i className="bi bi-caret-down-fill text-primary"></i>
                    </h2>
            </div>
            <div className="card-body">
                <div className="mb-4">
                    <Table useSlice={false} data={activity} columnName={["Type","Antall", "Andel"]} />
                </div>
                <DoughnutChart labels={activityChartLabels} datasets={activityChartDataset} />    
            </div>
            <div className="cc-click-stat-traffic" id="clickStatTraffic">
                <div className="card-header">
                    <h2><big className="fw-bold">{trafficTotalCount}</big> klikk fra 1881 til dine nettsider</h2>
                </div>
                <div className="card-body">
                    <div className="mb-4">
                        <Table useSlice={true} limit={5} data={traffic} useButton={true} highlightedWords={getItems} columnName={["Nettsted","Antall", "Andel"]} />
                    </div>
                    <DoughnutChart labels={trafficChartLabels} datasets={trafficChartDataset} /> 
                </div>
            </div>
        </div>
    );
}

export default ActivityAndTraffic;